<script lang="ts">
  import AtomButton from '../atoms/AtomButton.svelte'
  import type { ButtonType, ButtonVariant } from '../models'

  type ModalButton = {
    text: string
    variant: ButtonVariant
    action: () => void
    type?: ButtonType
    disabled?: boolean
    loading?: boolean
    class?: string
    hidden?: boolean
    icon?: any
  }

  export let firstButton: ModalButton | undefined = undefined
  export let secondButton: ModalButton | undefined = undefined
  export let thirdButton: ModalButton | undefined = undefined
  export let completeButton = null as any
</script>

<div class="flex flex-col sm:flex-row-reverse gap-2">
  {#if firstButton && !firstButton.hidden}
    <AtomButton
      text={firstButton.text}
      bind:this={completeButton}
      fullWidth="sm"
      variant={firstButton.variant}
      loading={firstButton.loading}
      disabled={firstButton.disabled}
      class={firstButton.class}
      icon={firstButton.icon}
      on:click={firstButton.action}
    />
  {/if}
  {#if secondButton && !secondButton.hidden}
    <AtomButton
      text={secondButton.text}
      bind:this={completeButton}
      fullWidth="sm"
      variant={secondButton.variant}
      loading={secondButton.loading}
      disabled={secondButton.disabled}
      class={secondButton.class}
      icon={secondButton.icon}
      on:click={secondButton.action}
    />
  {/if}
  {#if thirdButton && !thirdButton.hidden}
    <AtomButton
      text={thirdButton.text}
      bind:this={completeButton}
      fullWidth="sm"
      variant={thirdButton.variant}
      loading={thirdButton.loading}
      disabled={thirdButton.disabled}
      class={thirdButton.class}
      icon={thirdButton.icon}
      on:click={thirdButton.action}
    />
  {/if}
</div>
